import React from "react"
import { ThemeProvider } from "styled-components"

import componentThemeExtension from "utils/componentThemeExtension"

import PageNavigation from "components/page-navigation"
import ContentfulButton from "./button"

const ContentfulPageNavigationBar = ({ component, componentRefs, hideMainNavOnMobile }) => {
  const { id, backgroundColor, navigationAnchors, ctaButton, hideOnPageLoad } = component

  return (
    <ThemeProvider theme={componentThemeExtension(backgroundColor)}>
      <PageNavigation
        hideMainNavOnMobile={hideMainNavOnMobile}
        hideOnPageLoad={hideOnPageLoad}
        dataId={id}
        sectionRefs={componentRefs}
        items={navigationAnchors?.map((anchor) => ({
          anchor: anchor.anchorId,
          text: anchor.title,
        }))}
        buttonElement={
          ctaButton && (
            <ContentfulButton
              component={{
                ...ctaButton,
                size: "Small",
                disclaimerText: null,
                discountText: null,
              }}
            />
          )
        }
      />
    </ThemeProvider>
  )
}

export default ContentfulPageNavigationBar
